import React, { useMemo } from 'react';
import { IntlProvider } from 'react-intl';
import { useAppSelector } from 'app/hooks';
import messages from 'i18n/messages';
import { selectLocale } from 'features/settings/settingsSelectors';
import { selectFieldLabels } from 'features/fieldLabels/fieldLabelsSelectors';
import { expandFieldLabels } from 'i18n/fieldLabels';

const Wrapper = ({ children }) => {
  const locale = useAppSelector(selectLocale);
  const fieldLabels = useAppSelector(selectFieldLabels);

  // Las etiquetas renombradas por grupo pisan a los literales del JSON. Si el grupo no
  // tiene nada configurado el merge es vacío y queda el i18n de siempre.
  const localeMessages = useMemo(
    () => ({ ...messages[locale], ...expandFieldLabels(fieldLabels) }),
    [locale, fieldLabels],
  );

  return (
    <IntlProvider locale={locale} messages={localeMessages}>
      {children}
    </IntlProvider>
  );
};

export default Wrapper;
